var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmbedHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 25.5,
    height: 25.5,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11H4M16 19.5L18.5 17L16 14.5M12 14.5L9.5 17L12 19.5M4 9.8L4 18.2C4 19.8802 4 20.7202 4.32698 21.362C4.6146 21.9265 5.07354 22.3854 5.63803 22.673C6.27976 23 7.11984 23 8.8 23H19.2C20.8802 23 21.7202 23 22.362 22.673C22.9265 22.3854 23.3854 21.9265 23.673 21.362C24 20.7202 24 19.8802 24 18.2V9.8C24 8.11984 24 7.27977 23.673 6.63803C23.3854 6.07354 22.9265 5.6146 22.362 5.32698C21.7202 5 20.8802 5 19.2 5L8.8 5C7.11984 5 6.27976 5 5.63803 5.32698C5.07354 5.6146 4.6146 6.07354 4.32698 6.63803C4 7.27976 4 8.11984 4 9.8Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedHeaderIcon);
export default __webpack_public_path__ + "static/media/embed-header-icon.7db7e86604e856df8d1b60b37d26ae66.svg";
export { ForwardRef as ReactComponent };